import type { IconProps as DSIconProps } from '@eqi-investimentos/react';
import type { FC } from 'react';
import * as EQIIcons from '@eqi-investimentos/icons/web';
import type { IconsNames } from '@eqi-investimentos/icons/web';
export const Icon: FC<IconProps> = ({
  iconName,
  className = '',
  width = 8,
  height = 8,
  color = 'graph.gray.3',
  ...props
}) => {
  const CustomIcon = EQIIcons[iconName];
  return <CustomIcon data-testid={iconName} className={className} width={width} height={height} color={color} {...props} data-sentry-element="CustomIcon" data-sentry-component="Icon" data-sentry-source-file="index.tsx" />;
};
export type IconProps = Omit<DSIconProps, 'className' | 'width' | 'height' | 'color' | 'children'> & {
  iconName: IconsNames;
  className?: string;
  width?: number | `${number}px`;
  height?: number | `${number}px`;
  color?: string;
};